import { render } from "./MainTypeOfDocuments.vue?vue&type=template&id=1498807e&scoped=true"
import script from "./MainTypeOfDocuments.vue?vue&type=script&lang=js"
export * from "./MainTypeOfDocuments.vue?vue&type=script&lang=js"

import "./MainTypeOfDocuments.vue?vue&type=style&index=0&id=1498807e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1498807e"]])

export default __exports__